import axios from "services/interceptor/Interceptor";

export const callTypes = {
  get: "GET",
  post: "POST",
  upload: "UPLOAD",
  put: "PUT",
  delete: "DELETE",
  patch: "PATCH",
};

export async function showToast(error) {
  let errorMsg = [];
  if (error?.data?.information) {
    errorMsg = error?.data?.information;
  } else {
    errorMsg = "oppsWrong";
  }
  if (
    (error?.response?.data?.information || error?.data?.information) &&
    (error?.data?.information[0]?.code === "400TE" || error?.data?.information[0]?.code === "400TI" ||
      error?.response?.data?.information[0]?.code === "400TE")
  ) {
    window.localStorage.clear();
    window.location.reload();
  } else if (error?.data || error?.data?.information) {
    return false;
  }
}

export default async function callWebService(requestType, data, url, config, queryParams = {}) {
  switch (requestType) {
    case callTypes.get: {
      const getApiResult = await axios.get(url, { params: queryParams }).catch(async (error) => {
        if (error.response) await showToast(error);
        return error?.response;
      });
      return getApiResult;
    }
    case callTypes.post: {
      const postApiResult = await axios
        .post(url, data, config)
        .catch(async (error) => {
          if (error.response) await showToast(error.response);
          return error?.response;
        });
      return postApiResult;
    }
    case callTypes.put: {
      const putApiResult = await axios.put(url, data).catch(async (error) => {
        if (error.response) await showToast(error.response);
      });
      return putApiResult;
    }
    case callTypes.delete: {
      const deleteApiResult = await axios
        .delete(url, { data })
        .catch(async (error) => {
          if (error.response) await showToast(error.response);
        });
      return deleteApiResult;
    }
    case callTypes.patch: {
      const patchApiResult = await axios
        .patch(url, data)
        .catch(async (error) => {
          if (error.response) await showToast(error.response);
        });
      return patchApiResult;
    }
    default:
      return;
  }
}
